import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import ChartCard from './ChartCard';
import CnxModSummaryCards from './CnxModSummaryCards';
import TopDestinationsChart from './TopDestinationsChart';
import ReasonsChart from './ReasonsChart';
import InitiatorChart from './InitiatorChart';

const CnxModSection = ({ cnxMod, darkMode }) => {
  return (
    <React.Fragment>
      <Row className="mb-4">
        <Col lg={12}>
          <CnxModSummaryCards cnxMod={cnxMod} />
        </Col>
      </Row>
      <Row className="mb-4">
        <Col lg={6}>
          <ChartCard
            id="top-cnx-destinations"
            title="Top 5 CNX/MOD Destinations"
            icon="fa fa-map-marker"
            headerColor="#e74a3b"
            darkMode={darkMode}
          >
            <TopDestinationsChart data={cnxMod.topDestinations} />
          </ChartCard>
        </Col>
        <Col lg={6}>
          <ChartCard
            id="cnx-reasons"
            title="CNX/MOD Reasons"
            icon="fa fa-question-circle"
            headerColor="#f6c23e"
            darkMode={darkMode}
          >
            <ReasonsChart data={cnxMod.byReason} />
          </ChartCard>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col lg={12}>
          <ChartCard
            id="cnx-initiators"
            title="CNX/MOD Initiators"
            icon="fa fa-user"
            headerColor="#36b9cc"
            darkMode={darkMode}
          >
            <InitiatorChart data={cnxMod.byInitiator} />
          </ChartCard>
        </Col>
      </Row>
    </React.Fragment>
  );
};

CnxModSection.propTypes = {
  cnxMod: PropTypes.shape({
    totalCount: PropTypes.number,
    cancelledCount: PropTypes.number,
    modifiedCount: PropTypes.number,
    totalCost: PropTypes.number,
    cancellationFees: PropTypes.number,
    modificationFees: PropTypes.number,
    topDestinations: PropTypes.arrayOf(
      PropTypes.shape({
        country: PropTypes.string.isRequired,
        cost: PropTypes.number.isRequired,
      })
    ),
    byReason: PropTypes.arrayOf(
      PropTypes.shape({
        reason: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired,
        cost: PropTypes.number.isRequired,
      })
    ),
    byInitiator: PropTypes.arrayOf(
      PropTypes.shape({
        who: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired,
        cost: PropTypes.number.isRequired,
      })
    ),
  }).isRequired,
  darkMode: PropTypes.bool.isRequired,
};

export default CnxModSection;
